import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/** Aparición suave al entrar en pantalla: fade + leve movimiento hacia arriba. */
export function Reveal({
  children,
  delay = 0,
  className
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) {
    return <div className={className} data-id="element-591" data-mp="tevhebbs2rgc">{children}</div>;
  }
  return <motion.div className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15,
    margin: '-40px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-592" data-mp="5sf998nlho6p">
      {children}
    </motion.div>;
}